import React, { Component } from "react";
import { Button, withStyles, Typography } from "@material-ui/core";
import fire from "../index.js";
import parser from "csvtojson";
import { CSVLink } from "react-csv";
import InstructionText from "./InstructionText";

const placesCollection = "map-data-test";

const parserParams = {
  delimiter: [";", ","]
}

const PositiveMessage = withStyles({
  root: {
    color: "green",
  },
})(Typography);

const NegativeMessage = withStyles({
  root: {
    color: "red",
  },
})(Typography);

class UploadApp extends Component {
  state = {
    file: null,
    currentData: null,
    message: "",
  };

  fileInput = React.createRef();

  render() {
    return (
      <div style={{ position: "sticky" }}>
        {this.displayMessage()}
        <br />
        <input
          type="file"
          ref={this.fileInput}
          onChange={this.handleChange}
        ></input>
        <br />
        <Button variant="contained" onClick={this.handleSubmit}>
          submit file
        </Button>
        <br />
        {this.renderDownloadLink()}
        <br />
        <InstructionText />
        <a href="./instructions.pdf">
          click here for more detailed instructions
        </a>
      </div>
    );
  }

  async componentDidMount() {
    this.state.currentData = await this.FirestoreToCSV();
  }

  displayMessage = () => {
    if (this.state.message === "file successfully uploaded") {
      return (
        <PositiveMessage variant="button">{this.state.message}</PositiveMessage>
      );
    } else {
      return (
        <NegativeMessage variant="button">{this.state.message}</NegativeMessage>
      );
    }
  };

  renderDownloadLink = () => {
    if (this.state.currentData !== null) {
      return (
        <CSVLink data={this.state.currentData}>
          Click here to download current database!
        </CSVLink>
      );
    }
  };

  handleChange = (event) => {
    event.preventDefault();
    this.setState({
      file: this.fileInput.current.files[0],
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.state.file === null) {
      this.setState({
        message: "No file chosen!",
      });
      return;
    }
    try {
      this.parseFile();
    } catch (error) {
      this.setState({
        message: "Couldn't upload data to database. Please contact app admin to resolve this."
      })
    }
  };

  

  extractPlaceValues(csvRow) {
    var place = {};
    place["name"] = csvRow.name;
    place["population"] = parseInt(csvRow.population);
    place["client_type"] = csvRow.client_type.normalize();
    place["location"] = {
      latitude: parseFloat(csvRow.latitude),
      longitude: parseFloat(csvRow.longitude),
    };
    return place;
  }

  extractYearValues(csvRow) {
    var year = {};
    year["voters_count"] = parseInt(csvRow.voters_count);
    year["budget"] = parseInt(csvRow.budget);
    year["provider"] = csvRow.provider.toUpperCase() === "ANO" ? "participace21" : "ostatni";
    year["link"] = csvRow.link;
    year["year"] = parseInt(csvRow.year);
    year["still_active"] = csvRow.still_active.toUpperCase() === "ANO";
    return year;
  }

  async FirestoreToCSV() {
    const placesSnapshot = await fire
      .firestore()
      .collection(placesCollection)
      .get();
    const data = [];
    for (let i = 0; i < placesSnapshot.docs.length; i++) {
      data.push(placesSnapshot.docs[i].data());
    }
    this.setState({
      currentData: this.JSONDatatoCSV(data),
    });
  }

  JSONDatatoCSV(jsonData) {
    var csv = [];
    csv.push([
      "name",
      "year",
      "population",
      "voters_count",
      "budget",
      "client_type",
      "provider",
      "link",
      "latitude",
      "longitude",
      "still_active"
    ]);
    console.log(jsonData);
    jsonData.forEach((place) => {
      place.years.forEach((year) => {
        csv.push([
          place.name,
          year.year,
          place.population,
          year.voters_count,
          year.budget,
          place.client_type,
          year.provider === "participace21" ? "ANO" : "",
          year.link,
          place.location.latitude,
          place.location.longitude,
          year.still_active ? "ANO" : ""
        ]);
      });
    });
    return csv;
  }

  processData = (data) => {
    try {
      console.log(data);
      const preprocessedData = this.preprocessData(data);
      preprocessedData.forEach((row) => {
        this.addPlaceToFirebase(row);
        console.log("adding place");
      });
      console.log("upload complete");
      this.setState({ message: "file successfully uploaded" });
    }catch(error) {
      this.setState({
        message: "File is in invalid format! Please read instructions and correct the file correspondingly."
      })
    }

  };

  getDuplicate(processedData, name) {
    for (let index = 0; index < processedData.length; index++) {
      const element = processedData[index];
      if (element.name === name) {
        return element;
      }
    }
    return null;
  }

  containsYear(years, year) {
    for (let index = 0; index < years.length; index++) {
      const element = years[index];
      if (element.year === year) {
        return true;
      }
    }
    return false;
  }

  preprocessData(data) {
    const processedData = [];
    data.forEach((element) => {
      var duplicate = this.getDuplicate(processedData, element.name);
      if (duplicate === null) {
        var place = this.extractPlaceValues(element);
        var year = this.extractYearValues(element);
        processedData.push({
          ...place,
          years: [year],
        });
      } else {
        var year = this.extractYearValues(element);
        if (this.containsYear(duplicate.years, year.year)) {
          this.state.message =
            "MULTIPLE OCCURENCES OF THE SAME YEAR AND NAME (FIRST ONE WILL BE UPLOADED)";
        } else {
          duplicate.years.push(year);
        }
      }
    });
    return processedData;
  }

  addPlaceToFirebase = (data) => {
    const dbRef = fire.firestore();
    const docRef = dbRef.collection(placesCollection).doc(data.name);
    docRef.get().then((doc) => {
      if (doc.exists) {
        this.setState({
          message: "place already exists in the database", //shouldn't even be called
        });
      } else {
        this.addNonexistentPlace(data, docRef);
      }
    });
  };

  addNonexistentPlace(data, docRef) {
    docRef.set(data);
  }

  deleteDataCollection = async () => {
    const ref = fire.firestore().collection(placesCollection);
    const promises = [];
    await ref.get().then((snapshot) => {
      snapshot.forEach((doc) => {
        console.log("deleting data");
        promises.push(ref.doc(doc.id).delete());
      });
    });
    await Promise.all(promises);
  };

  parseFile = async () => {
    var csvText;
    await this.deleteDataCollection();
    console.log("deletion complete");
    this.state.file.text().then((text) => {
      csvText = text;
      parser(parserParams)
        .fromString(csvText)
        .then((source) => {
          this.processData(source);
        });
    });
  };
}

export default UploadApp;
